export default {"src":"/_next/static/media/infosys.f24cfabf.svg","height":107,"width":290,"blurWidth":0,"blurHeight":0};